const containerStyles = (tokens) => ({
    baseStyle: {
        color: tokens.CanvasPrimary,
    },
});
export default containerStyles;
